import { SplunkIconUrl } from "@p0security/integrations-splunk-events-shared";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { SplunkStackAccessesHackyCopyOfManifestAvoidReuse } from "./accesses.ts";
import { SplunkStackComponents } from "./components.ts";

const SplunkStackFilters = {
  role: { keys: ["id"] },
  stackNode: { keys: ["stackNode"] },
} as const satisfies AnyFilterSchema;

export type SplunkStackFilters = typeof SplunkStackFilters;

export const SplunkStackRegistration = Registration({
  accesses: SplunkStackAccessesHackyCopyOfManifestAvoidReuse,
  category: "resource",
  components: SplunkStackComponents,
  docs: {},
  filters: SplunkStackFilters,
  flag: "stack-access-ui-integration",
  itemKind: "resource",
  label: "Splunk Stack Access",
  logoUrl: SplunkIconUrl,
  maturity: "ga",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("splunk-stack", SplunkStackRegistration);
